import { LoginLinks } from '../shared/links-footer/models/login-links.model';

export const brazilLinks: LoginLinks = {
  backToTownSqLink: 'https://townsq.com.br/',
  helpCenterLink: 'https://townsq.octadesk.com/kb',
  termsOfUseLink: 'https://www.townsq.com.br/termos-de-uso-e-servicos/',
  supportContactLink: 'https://api.whatsapp.com/send?phone=555130248787',
};

export const unitedStatesLinks: LoginLinks = {
  backToTownSqLink: 'https://www.townsq.io/',
  termsOfUseLink: 'http://terms.townsq.io',
  privacyPolicyLink: 'http://privacy.townsq.io',
  supportContactLink: 'https://www.townsq.io/support',
};
